<script setup lang="ts">
import Header from './components/Header.vue'
import { useZone } from './composables/useZone'
import { useSecurity } from './composables/useSecurity'
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Loading from '@/components/ui/Loading/index.vue'

const route = useRoute()
const hideHeader = computed(() => Boolean(route.meta?.hideAppHeader))
const fullBleed = computed(() => Boolean(route.meta?.fullBleed))
const isUpsellEditor = computed(() => route.name === 'FunnelUpsellView')
const mainClass = computed(() => {
  if (fullBleed.value) {
    return 'flex-grow h-screen overflow-y-auto bg-gray-50'
  }
  if (isUpsellEditor.value) {
    return 'flex-grow h-[calc(100vh-4.8rem)] overflow-y-auto bg-gray-50 p-4'
  }
  return 'flex-grow h-[calc(100vh-65px)] overflow-y-auto bg-gray-50 p-4'
})

const { setCountries } = useZone()
const { performSecurityCheck } = useSecurity()

onMounted(() => {
  setCountries()
  performSecurityCheck()
})

// 配置黑色主题
const theme = {
  token: {
    colorPrimary: '#000000',
    colorInfo: '#000000',
    colorLink: '#000000',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    borderRadius: 6,
  },
  components: {
    Button: {
      colorPrimary: '#000000',
      algorithm: true,
      boxShadow: 'none',
      boxShadowSecondary: 'none',
    },
    Input: {
      colorPrimary: '#000000',
      colorPrimaryHover: '#262626',
    },
    Select: {
      colorPrimary: '#000000',
      colorPrimaryHover: '#262626',
      optionSelectedBg: '#f5f5f5',
      optionActiveBg: '#f5f5f5',
      controlItemBgActive: '#f5f5f5',
      controlItemBgHover: '#f0f0f0',
    },
    Checkbox: {
      colorPrimary: '#000000',
      colorPrimaryHover: '#262626',
    },
    Radio: {
      colorPrimary: '#000000',
      colorPrimaryHover: '#262626',
    },
    Switch: {
      colorPrimary: '#000000',
      colorPrimaryHover: '#262626',
    },
    DatePicker: {
      colorPrimary: '#000000',
      colorPrimaryHover: '#262626',
    },
    Tabs: {
      colorPrimary: '#000000',
    },
  },
}
</script>

<template>
  <a-config-provider :theme="theme">
    <div class="flex flex-col min-h-screen">
      <Loading />
      <Header v-if="!hideHeader" />
      <main :class="mainClass">
        <router-view />
      </main>
    </div>
  </a-config-provider>
</template>

<style scoped>

</style>
